import type React from "react"
import { Box, Button, Typography } from "@mui/material"
import ShareIcon from "@mui/icons-material/Share"
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder"
import FavoriteIcon from "@mui/icons-material/Favorite"
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf"
import { useProperty } from "../../context/PropertyContext"

interface PropertyHeaderProps {
  property: any
  onShare: () => void
  onViewPDF: () => void
  onFavorite: (event: React.MouseEvent) => void
}

const PropertyHeader = ({ property, onShare, onViewPDF, onFavorite }: PropertyHeaderProps) => {
  const { favorites } = useProperty()
  const isFavorite = favorites.has(property.id_Property)

  const handleFavorite = (event: React.MouseEvent) => {
    onFavorite(event)
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        mb: 2,
        mt: 4,
      }}
    >
      {/* Título */}
      <Typography
        variant="h6"
        fontSize="30px"
        sx={{
          flexBasis: { xs: "100%", sm: "auto" },
          textAlign: { xs: "center", sm: "left" },
          order: { xs: 1, sm: 0 },
          mb: { xs: 2, sm: 0 },
        }}
      >
        {property.title}
      </Typography>

      {/* Botones de acción */}
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: { xs: "center", sm: "flex-end" },
          gap: 2,
          flexGrow: 1,
          order: { xs: 2, sm: 1 },
        }}
      >
        <Button
          onClick={onShare}
          sx={{
            display: "flex",
            alignItems: "center",
            color: "black",
          }}
        >
          <ShareIcon sx={{ color: "green" }} />
          <Typography variant="body1" sx={{ ml: 1, textDecoration: "underline" }}>
            Compartir
          </Typography>
        </Button>
        <Button
          onClick={handleFavorite}
          sx={{
            display: "flex",
            alignItems: "center",
            color: "black",
          }}
        >
          {isFavorite ? <FavoriteIcon sx={{ color: "green" }} /> : <FavoriteBorderIcon sx={{ color: "green" }} />}
          <Typography variant="body1" sx={{ ml: 1, textDecoration: "underline", color: "black" }}>
            Guardar
          </Typography>
        </Button>
        <Button
          onClick={onViewPDF}
          startIcon={<PictureAsPdfIcon sx={{ color: "green" }} />}
          sx={{
            display: "flex",
            alignItems: "center",
            color: "black",
          }}
        >
          <Typography variant="body1" sx={{ ml: 1, textDecoration: "underline", color: "black" }}>
            Descargar
          </Typography>
        </Button>
      </Box>
    </Box>
  )
}

export default PropertyHeader
